import { Button } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';

import { black } from 'utils/color-styles';

const styles = {
  tabsContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 25,
  },
  tabButton: {
    borderRadius: 0,
    margin: '0 8px',
    color: black,
  },
  notSelectedTab: {
    borderBottom: `2px solid black`,
  },
};

export const Tabs = ({ selectedTab }: { selectedTab: 'VolunteerReward' | 'VolunteerTimes' }) => (
  <div style={styles.tabsContainer}>
    <Button
      component={Link}
      color="secondary"
      variant="text"
      to="/volunteer-times"
      style={{
        borderBottom: selectedTab === 'VolunteerTimes' ? '2px solid black' : undefined,
        borderRadius: 0,
        margin: '0 8px',
        color: black,
        opacity: selectedTab !== 'VolunteerTimes' ? 0.8 : 1,
      }}
      disabled={selectedTab === 'VolunteerTimes'}
    >
      Volunteer Hours
    </Button>
    <Button
      component={Link}
      color="secondary"
      variant="text"
      to="/volunteer-rewards"
      style={{
        borderBottom: selectedTab === 'VolunteerReward' ? '2px solid black' : undefined,
        borderRadius: 0,
        margin: '0 8px',
        color: black,
        opacity: selectedTab !== 'VolunteerReward' ? 0.8 : 1,
      }}
      disabled={selectedTab === 'VolunteerReward'}
    >
      Volunteer Grants
    </Button>
  </div>
);
